// src/PosRunner.jsx
import React, { useEffect, useState } from 'react';
import axios from 'axios';
import SalesWindow from './SalesWindow';  // retail POS

const API_BASE = 'https://reactapp.kendiservers.com';

export default function PosRunner() {
  const [posType, setPosType] = useState(localStorage.getItem('pos_type') || '');
  const [loading, setLoading] = useState(!posType);
  const [err, setErr] = useState('');

  useEffect(() => {
    axios.defaults.baseURL = API_BASE;
    const sid = Number(localStorage.getItem('store_id') || 0);
    if (sid > 0) axios.defaults.headers.common['X-Store-ID'] = sid;

    if (!posType && sid) {
      setLoading(true);
      axios.get('/server.php', { params: { r: 'store-info' } })
        .then(res => {
          if (res.data?.success) {
            const t = res.data.store?.pos_type || 'retail';
            localStorage.setItem('pos_type', t);
            setPosType(t);
          } else {
            setErr(res.data?.message || 'Could not load store info');
          }
        })
        .catch(() => setErr('Server error loading store info'))
        .finally(() => setLoading(false));
    }
  }, []);

  if (err) return <div style={{padding:'1rem', color:'#b91c1c'}}>{err}</div>;
  if (loading) return <div style={{padding:'1rem'}}>Loading POS…</div>;

  if ((posType || '').toLowerCase() === 'retail') {
    return <SalesWindow onBack={() => window.history.back()} />;
  }

  return (
    <div style={{padding:'1rem'}}>
      <h2>POS Type: {posType}</h2>
      <p>No specialized UI yet. Falling back to Retail Sales Window:</p>
      <SalesWindow onBack={() => window.history.back()} />
    </div>
  );
}
